<div class="unauthorized-container">
  <div class="flex h-full items-center justify-center">
    <div class="max-w-[400px] text-center"
      >Sorry, you are not authorized to access this page. Please contact us at
      <a href="mailto:support@cargosignal.com" target="_blank" class="text-blue-600 hover:underline dark:text-blue-500"
        >support&#64;cargosignal.com</a
      >
      for assistance.</div
    >
  </div>
</div>
